import React from 'react';
import { cn } from '../../../lib/utils';
import { Input } from '../../../components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';
import { Search, Calendar } from 'lucide-react';
import { UniversityFiltersProps } from '../types';

export function UniversityFilters({
  isDark,
  searchQuery,
  onSearchChange,
  regionFilter,
  onRegionChange,
  regions,
  availableYears,
  selectedYear,
  onYearChange,
}: UniversityFiltersProps) {
  return (
    <div className="p-4 lg:p-5 flex flex-col sm:flex-row gap-3">
      <div className="relative flex-1">
        <Search className={cn(
          'absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4',
          isDark ? 'text-slate-500' : 'text-slate-400'
        )} />
        <Input
          placeholder="Search universities..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className={cn(
            'pl-10 rounded-xl',
            isDark
              ? 'bg-slate-800 border-slate-700 text-white placeholder:text-slate-500'
              : 'bg-white border-slate-200 placeholder:text-slate-400'
          )}
        />
      </div>

      {/* Year Filter */}
      <Select
        value={String(selectedYear)}
        onValueChange={(v) => onYearChange(Number(v))}
      >
        <SelectTrigger className={cn(
          'w-full sm:w-[140px] rounded-xl',
          isDark
            ? 'bg-slate-800 border-slate-700 text-white'
            : 'bg-white border-slate-200'
        )}>
          <Calendar className="w-4 h-4 mr-2 opacity-50" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {availableYears.length > 0 ? (
            availableYears.map((year) => (
              <SelectItem key={year} value={String(year)}>{year}</SelectItem>
            ))
          ) : (
            <SelectItem value="2024">2024</SelectItem>
          )}
        </SelectContent>
      </Select>

      {/* Region Filter */}
      <Select value={regionFilter || 'all'} onValueChange={(v) => onRegionChange(v === 'all' ? '' : v)}>
        <SelectTrigger className={cn(
          'w-full sm:w-[200px] rounded-xl',
          isDark
            ? 'bg-slate-800 border-slate-700 text-white'
            : 'bg-white border-slate-200'
        )}>
          <SelectValue placeholder="All Regions" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Regions</SelectItem>
          {regions.map((region) => (
            <SelectItem key={region} value={region}>{region}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
